import React, { Component } from 'react';
import { api } from '../utils/api';
import toast from 'react-hot-toast';
import { Plus, Search, Edit2, Trash2, RefreshCw, X, Save,
         ChevronDown, ChevronUp, ChevronLeft, ChevronRight,
         Users, Building2, Phone, Mail, Shield, Upload,
         ToggleLeft, ToggleRight, Check } from 'lucide-react';
import BulkAgentUpload from './BulkAgentUpload';

const INDIAN_STATES = ['Andhra Pradesh','Arunachal Pradesh','Assam','Bihar','Chhattisgarh','Goa','Gujarat','Haryana','Himachal Pradesh','Jharkhand','Karnataka','Kerala','Madhya Pradesh','Maharashtra','Manipur','Meghalaya','Mizoram','Nagaland','Odisha','Punjab','Rajasthan','Sikkim','Tamil Nadu','Telangana','Tripura','Uttar Pradesh','Uttarakhand','West Bengal','Delhi','Jammu & Kashmir','Ladakh','Chandigarh','Puducherry'];

const inp  = (err) => ({ width:'100%', background: err?'#FFF5F5':'#F9FAFB', border:`1.5px solid ${err?'#FCA5A5':'#D1D5DB'}`, borderRadius:10, padding:'9px 12px', fontFamily:'Sora,sans-serif', fontSize:13, color:'#111827', outline:'none', boxSizing:'border-box' });
const lbl  = { fontSize:11, fontWeight:700, letterSpacing:'0.08em', textTransform:'uppercase', color:'#6B7280', display:'block', marginBottom:5 };
const fg   = { display:'flex', flexDirection:'column', gap:4 };

const STEPS = [
  { id: 0, label: 'Agent Info',  icon: '🏢' },
  { id: 1, label: 'Branches',   icon: '📍' },
  { id: 2, label: 'Brokers',    icon: '👥' },
];

function BranchRow({ b, idx, onChange, onRemove }) {
  return (
    <div style={{ background:'#F8FAFF', border:'1.5px solid #DBEAFE', borderRadius:12, padding:16, marginBottom:12, position:'relative' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:12 }}>
        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
          <div style={{ width:26, height:26, borderRadius:8, background:'#2F5FE0', display:'flex', alignItems:'center', justifyContent:'center', fontSize:11, fontWeight:700, color:'#fff' }}>{idx+1}</div>
          <span style={{ fontSize:13, fontWeight:700, color:'#16213E' }}>Branch {idx+1}</span>
        </div>
        <button onClick={()=>onRemove(idx)} style={{ background:'#FCEAE8', border:'1px solid #F5CAC5', borderRadius:7, padding:'5px 8px', cursor:'pointer', color:'#E1483A', display:'flex' }}><X size={13}/></button>
      </div>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
        {[['branch_name','Branch Name *'],['manager_name','Manager Name'],['manager_phone','Manager Phone'],['manager_email','Manager Email'],['gstin','GSTIN'],['billing_state','State']].map(([k,l])=>(
          <div key={k} style={fg}>
            <label style={lbl}>{l}</label>
            {k==='billing_state' ? (
              <select value={b[k]||''} onChange={e=>onChange(idx,k,e.target.value)} style={inp(false)}>
                <option value="">Select</option>
                {INDIAN_STATES.map(s=><option key={s}>{s}</option>)}
              </select>
            ) : (
              <input value={b[k]||''} onChange={e=>onChange(idx,k,e.target.value)} style={inp(false)} placeholder={k==='branch_name'?'e.g. Mumbai Branch':''} />
            )}
          </div>
        ))}
        <div style={{ ...fg, gridColumn:'1/-1' }}>
          <label style={lbl}>Address</label>
          <textarea rows={2} value={b.address||''} onChange={e=>onChange(idx,'address',e.target.value)} style={{ ...inp(false), resize:'vertical' }} />
        </div>
      </div>
    </div>
  );
}

function BrokerRow({ br, idx, onChange, onRemove, branches }) {
  return (
    <div style={{ background:'#F9FAFB', border:'1px solid #E5E7EB', borderRadius:10, padding:'12px 14px', marginBottom:8 }}>
      <div style={{ display:'flex', gap:8, alignItems:'flex-end' }}>
        <div style={{ width:26, height:26, borderRadius:8, background:'#7C3AED', display:'flex', alignItems:'center', justifyContent:'center', fontSize:11, fontWeight:700, color:'#fff', flexShrink:0, alignSelf:'center' }}>{idx+1}</div>
        {[['name','Broker Name *'],['email','Email'],['phone','Phone']].map(([k,l])=>(
          <div key={k} style={{ flex:1, ...fg }}>
            <label style={lbl}>{l}</label>
            <input value={br[k]||''} onChange={e=>onChange(idx,k,e.target.value)} style={inp(false)} placeholder={k==='name'?'e.g. Amit Sharma':''} />
          </div>
        ))}
        <button onClick={()=>onRemove(idx)} style={{ background:'#FCEAE8', border:'1px solid #F5CAC5', borderRadius:8, padding:'9px 10px', cursor:'pointer', color:'#E1483A', flexShrink:0 }}><X size={13}/></button>
      </div>
      <div style={{ marginTop:10 }}>
        <label style={lbl}>Assign to Branch</label>
        <select value={br.branch_name||''} onChange={e=>onChange(idx,'branch_name',e.target.value)}
          style={{ ...inp(false), background: br.branch_name ? '#F0FDF4' : '#F9FAFB' }}>
          <option value="">-- No specific branch (agency-level) --</option>
          {(branches||[]).filter(b=>b.branch_name?.trim()).map((b,i)=>(
            <option key={i} value={b.branch_name}>{b.branch_name}{b.manager_name ? ` (${b.manager_name})` : ''}</option>
          ))}
        </select>
        {br.branch_name && (
          <p style={{ fontSize:11, color:'#0FA968', marginTop:3 }}>✓ Assigned to {br.branch_name}</p>
        )}
      </div>
    </div>
  );
}

class AgentModal extends Component {
  constructor(props) {
    super(props);
    const a = props.agent;
    let loadedBrokers = a?.brokers || [];
    if (loadedBrokers.length && a?.branches?.length) {
      const idToName = {};
      (a.branches||[]).forEach(b => { idToName[b.id] = b.branch_name; });
      loadedBrokers = loadedBrokers.map(bk => ({
        ...bk,
        branch_name: bk.branch_id ? (idToName[bk.branch_id] || '') : '',
      }));
    }
    this.state = {
      step: 0,
      form: {
        agency_name: a?.agency_name||'', director_name: a?.director_name||'',
        registered_address: a?.registered_address||'', phone: a?.phone||'',
        email: a?.email||'', gstin: a?.gstin||'',
        billing_state: a?.billing_state||'',
        operation_type: a?.operation_type||'Single Branch',
        booking_limit: a?.booking_limit||'',
        agent_type: a?.agent_type||'Both',
      },
      branches: a?.branches||[],
      brokers:  loadedBrokers,
      saving: false, errors: {},
    };
  }

  handleChange(k, v) { this.setState(prev=>({ form:{...prev.form,[k]:v}, errors:{...prev.errors,[k]:''} })); }
  handleBranchChange(i, k, v) { this.setState(prev=>{ const b=[...prev.branches]; b[i]={...b[i],[k]:v}; return {branches:b}; }); }
  addBranch()     { this.setState(prev=>({ branches:[...prev.branches,{branch_name:''}] })); }
  removeBranch(i) { this.setState(prev=>{ const b=[...prev.branches]; b.splice(i,1); return {branches:b}; }); }
  handleBrokerChange(i, k, v) { this.setState(prev=>{ const b=[...prev.brokers]; b[i]={...b[i],[k]:v}; return {brokers:b}; }); }
  addBroker()     { this.setState(prev=>({ brokers:[...prev.brokers,{name:''}] })); }
  removeBroker(i) { this.setState(prev=>{ const b=[...prev.brokers]; b.splice(i,1); return {brokers:b}; }); }

  validateStep(step) {
    if (step === 0) {
      if (!this.state.form.agency_name.trim()) {
        this.setState({ errors:{ agency_name:'Agency name is required' } });
        return false;
      }
    }
    return true;
  }

  handleNext()  { if (!this.validateStep(this.state.step)) return; this.setState(prev=>({ step: Math.min(prev.step + 1, STEPS.length - 1) })); }
  handleBack()  { this.setState(prev=>({ step: Math.max(prev.step - 1, 0) })); }

  async handleSubmit() {
    const { form, branches, brokers } = this.state;
    if (!form.agency_name.trim()) { this.setState({ errors:{ agency_name:'Required' }, step:0 }); return; }
    this.setState({ saving: true });
    try {
      const payload = { ...form, branches, brokers };
      let savedAgent = this.props.agent;
      if (this.props.agent) {
        await api.put(`/agents/${this.props.agent.id}`, payload);
        toast.success('Agent updated!');
      } else {
        const res = await api.post('/agents', payload);
        savedAgent = res.data?.data || { ...payload };
        toast.success('Agent added successfully!');
      }
      this.props.onSaved(savedAgent);
    } catch (e) { toast.error(e.response?.data?.message||'Save failed'); }
    finally { this.setState({ saving: false }); }
  }

  render() {
    const { onClose, agent } = this.props;
    const { form, branches, brokers, saving, errors, step } = this.state;

    return (
      <div style={{ position:'fixed', inset:0, zIndex:200, background:'rgba(0,0,0,0.45)', backdropFilter:'blur(4px)', display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
        <div style={{ background:'#fff', borderRadius:20, width:'100%', maxWidth:700, boxShadow:'0 24px 64px rgba(0,0,0,0.18)', overflow:'hidden', maxHeight:'92vh', display:'flex', flexDirection:'column' }}>
          <div style={{ background:'#16213E', padding:'18px 24px', display:'flex', alignItems:'center', justifyContent:'space-between', flexShrink:0 }}>
            <div style={{ display:'flex', alignItems:'center', gap:10 }}>
              <Users size={18} color="#C9A84C" />
              <span style={{ fontSize:16, fontWeight:700, color:'#fff' }}>{agent ? 'Edit Agent' : 'Add New Agent'}</span>
            </div>
            <button onClick={onClose} style={{ background:'rgba(255,255,255,0.12)', border:'none', borderRadius:8, padding:6, cursor:'pointer', color:'#fff', display:'flex' }}><X size={18}/></button>
          </div>

          <div style={{ padding:'16px 24px', borderBottom:'1px solid #E5E7EB', background:'#FAFBFF', flexShrink:0 }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:0 }}>
              {STEPS.map((s, i) => (
                <React.Fragment key={s.id}>
                  <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:4 }}>
                    <div onClick={() => i < step && this.setState({ step: i })}
                      style={{ width:38, height:38, borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', fontSize:16, fontWeight:700, cursor: i < step ? 'pointer' : 'default', background: i < step ? '#0FA968' : i === step ? '#16213E' : '#E5E7EB', color: i <= step ? '#fff' : '#9CA3AF', border: i === step ? '3px solid #C9A84C' : '3px solid transparent', transition:'all 0.2s' }}>
                      {i < step ? <Check size={16} /> : s.icon}
                    </div>
                    <span style={{ fontSize:11, fontWeight: i===step?700:500, color: i===step?'#16213E': i<step?'#0FA968':'#9CA3AF', whiteSpace:'nowrap' }}>{s.label}</span>
                  </div>
                  {i < STEPS.length - 1 && (
                    <div style={{ width:60, height:2, background: i < step ? '#0FA968' : '#E5E7EB', margin:'0 4px', marginTop:-20, transition:'background 0.3s' }} />
                  )}
                </React.Fragment>
              ))}
            </div>
          </div>

          <div style={{ padding:24, overflowY:'auto', flex:1 }}>
            {step === 0 && (
              <div>
                <div style={{ marginBottom:16, padding:'10px 14px', background:'#EFF6FF', border:'1px solid #BFDBFE', borderRadius:10, fontSize:13, color:'#1D4ED8' }}>
                  <strong>Step 1:</strong> Enter the agent / travel agency details
                </div>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
                  <div style={{ ...fg, gridColumn:'1/-1' }}>
                    <label style={lbl}>Agency Name *</label>
                    <input value={form.agency_name} onChange={e=>this.handleChange('agency_name',e.target.value)} style={inp(errors.agency_name)} placeholder="e.g. Kabra Travel Services Pvt. Ltd." autoFocus />
                    {errors.agency_name && <p style={{ fontSize:11, color:'#E1483A', margin:0 }}>{errors.agency_name}</p>}
                  </div>
                  <div style={fg}><label style={lbl}>Director / Proprietor</label><input value={form.director_name} onChange={e=>this.handleChange('director_name',e.target.value)} style={inp(false)} placeholder="e.g. Rahul Kabra" /></div>
                  <div style={fg}><label style={lbl}>Phone</label><input value={form.phone} onChange={e=>this.handleChange('phone',e.target.value)} style={inp(false)} placeholder="+91 98765 43210" /></div>
                  <div style={fg}><label style={lbl}>Email</label><input value={form.email} onChange={e=>this.handleChange('email',e.target.value)} style={inp(false)} placeholder="agency@example.com" /></div>
                  <div style={fg}><label style={lbl}>GSTIN</label><input value={form.gstin} onChange={e=>this.handleChange('gstin',e.target.value.toUpperCase())} style={inp(false)} placeholder="27AAAAA0000A1Z5" /></div>
                  <div style={fg}>
                    <label style={lbl}>Billing State</label>
                    <select value={form.billing_state} onChange={e=>this.handleChange('billing_state',e.target.value)} style={inp(false)}>
                      <option value="">Select state</option>
                      {INDIAN_STATES.map(s=><option key={s}>{s}</option>)}
                    </select>
                  </div>
                  <div style={fg}>
                    <label style={lbl}>Operation Type</label>
                    <select value={form.operation_type} onChange={e=>this.handleChange('operation_type',e.target.value)} style={inp(false)}>
                      <option>Single Branch</option><option>Multiple Branches</option>
                    </select>
                  </div>
                  <div style={fg}>
                    <label style={lbl}>Agent Type</label>
                    <select value={form.agent_type||'Both'} onChange={e=>this.handleChange('agent_type',e.target.value)} style={inp(false)}>
                      <option value="Buyers">Buyers</option>
                      <option value="Seller">Seller</option>
                      <option value="Both">Both</option>
                    </select>
                  </div>
                  <div style={fg}><label style={lbl}>Booking Limit</label><input type="number" value={form.booking_limit} onChange={e=>this.handleChange('booking_limit',e.target.value)} style={inp(false)} placeholder="Leave blank = no limit" /></div>
                  <div style={{ ...fg, gridColumn:'1/-1' }}>
                    <label style={lbl}>Registered Address</label>
                    <textarea rows={3} value={form.registered_address} onChange={e=>this.handleChange('registered_address',e.target.value)} style={{ ...inp(false), resize:'vertical' }} placeholder="Full registered address..." />
                  </div>
                </div>
              </div>
            )}

            {step === 1 && (
              <div>
                <div style={{ marginBottom:16, padding:'10px 14px', background:'#EFF6FF', border:'1px solid #BFDBFE', borderRadius:10, fontSize:13, color:'#1D4ED8' }}>
                  <strong>Step 2:</strong> Add branches of <strong>{form.agency_name}</strong>
                  <span style={{ color:'#6B7280', fontWeight:400 }}> — each branch can have its own manager, contact and billing state</span>
                </div>
                {branches.length === 0 && (
                  <div style={{ textAlign:'center', padding:'30px 0', color:'#9CA3AF' }}>
                    <Building2 size={32} style={{ marginBottom:10, color:'#D1D5DB' }} />
                    <p style={{ fontSize:14, fontWeight:600, color:'#6B7280' }}>No branches added yet</p>
                  </div>
                )}
                {branches.map((b,i)=>(
                  <BranchRow key={i} b={b} idx={i} onChange={(i,k,v)=>this.handleBranchChange(i,k,v)} onRemove={(i)=>this.removeBranch(i)} />
                ))}
                <button onClick={()=>this.addBranch()} style={{ display:'flex', alignItems:'center', gap:6, padding:'10px 18px', borderRadius:10, border:'1.5px dashed #2F5FE0', background:'#EFF6FF', fontSize:13, fontWeight:600, color:'#2F5FE0', cursor:'pointer', width:'100%', justifyContent:'center' }}>
                  <Plus size={14}/> Add Branch
                </button>
                {branches.length > 0 && (
                  <div style={{ marginTop:20, padding:'12px 16px', background:'#F0FDF4', border:'1px solid #BBF7D0', borderRadius:10 }}>
                    <p style={{ fontSize:11, fontWeight:700, textTransform:'uppercase', letterSpacing:'0.08em', color:'#0B7A4C', marginBottom:8 }}>Structure Preview</p>
                    <div style={{ fontSize:13, color:'#374151', lineHeight:1.8 }}>
                      <div style={{ fontWeight:700, color:'#16213E' }}>🏢 {form.agency_name}</div>
                      {branches.map((b,i)=>(
                        <div key={i} style={{ paddingLeft:20 }}>
                          <span style={{ color:'#6B7280' }}>└─ </span>
                          <span style={{ fontWeight:600, color:'#2F5FE0' }}>📍 {b.branch_name||`Branch ${i+1}`}</span>
                          {b.manager_name && <span style={{ color:'#9CA3AF', fontSize:12 }}> ({b.manager_name})</span>}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}

            {step === 2 && (
              <div>
                <div style={{ marginBottom:16, padding:'10px 14px', background:'#F5F3FF', border:'1px solid #DDD6FE', borderRadius:10, fontSize:13, color:'#5B21B6' }}>
                  <strong>Step 3:</strong> Add brokers / sub-agents associated with <strong>{form.agency_name}</strong>
                  <span style={{ color:'#6B7280', fontWeight:400 }}> — optional</span>
                </div>
                {brokers.length === 0 && (
                  <div style={{ textAlign:'center', padding:'30px 0', color:'#9CA3AF' }}>
                    <Users size={32} style={{ marginBottom:10, color:'#D1D5DB' }} />
                    <p style={{ fontSize:14, fontWeight:600, color:'#6B7280' }}>No brokers added yet</p>
                  </div>
                )}
                {brokers.map((br,i)=>(
                  <BrokerRow key={i} br={br} idx={i} branches={branches} onChange={(i,k,v)=>this.handleBrokerChange(i,k,v)} onRemove={(i)=>this.removeBroker(i)} />
                ))}
                <button onClick={()=>this.addBroker()} style={{ display:'flex', alignItems:'center', gap:6, padding:'10px 18px', borderRadius:10, border:'1.5px dashed #7C3AED', background:'#F5F3FF', fontSize:13, fontWeight:600, color:'#7C3AED', cursor:'pointer', width:'100%', justifyContent:'center' }}>
                  <Plus size={14}/> Add Broker
                </button>
                {(branches.length > 0 || brokers.length > 0) && (
                  <div style={{ marginTop:20, padding:'14px 16px', background:'#F0FDF4', border:'1px solid #BBF7D0', borderRadius:10 }}>
                    <p style={{ fontSize:11, fontWeight:700, textTransform:'uppercase', letterSpacing:'0.08em', color:'#0B7A4C', marginBottom:10 }}>Final Structure Preview</p>
                    <div style={{ fontSize:13, color:'#374151', lineHeight:2 }}>
                      <div style={{ fontWeight:700, color:'#16213E' }}>🏢 {form.agency_name}</div>
                      {branches.map((b,i)=>{
                        const branchBrokers = brokers.filter(br => br.branch_name === b.branch_name);
                        return (
                          <div key={i}>
                            <div style={{ paddingLeft:20 }}><span style={{ color:'#6B7280' }}>├─ </span><span style={{ fontWeight:600, color:'#2F5FE0' }}>📍 {b.branch_name||`Branch ${i+1}`}</span>{b.manager_name && <span style={{ color:'#9CA3AF', fontSize:12 }}> · {b.manager_name}</span>}</div>
                            {branchBrokers.map((br,j)=>(<div key={j} style={{ paddingLeft:46 }}><span style={{ color:'#6B7280' }}>└─ </span><span style={{ fontWeight:600, color:'#7C3AED' }}>👤 {br.name||`Broker ${j+1}`}</span>{br.phone && <span style={{ color:'#9CA3AF', fontSize:12 }}> · {br.phone}</span>}</div>))}
                          </div>
                        );
                      })}
                      {brokers.filter(br => !br.branch_name).map((br,j)=>(
                        <div key={j} style={{ paddingLeft:20 }}><span style={{ color:'#6B7280' }}>└─ </span><span style={{ fontWeight:600, color:'#7C3AED' }}>👤 {br.name||`Broker ${j+1}`}</span>{br.phone && <span style={{ color:'#9CA3AF', fontSize:12 }}> · {br.phone}</span>}<span style={{ fontSize:11, color:'#D97706', marginLeft:6 }}>(agency-level)</span></div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>

          <div style={{ padding:'14px 24px', background:'#F9FAFB', borderTop:'1px solid #E5E7EB', display:'flex', justifyContent:'space-between', alignItems:'center', flexShrink:0 }}>
            <button onClick={step === 0 ? onClose : this.handleBack.bind(this)} style={{ display:'flex', alignItems:'center', gap:6, padding:'10px 18px', borderRadius:10, border:'1.5px solid #D1D5DB', background:'#fff', fontSize:13, fontWeight:600, color:'#374151', cursor:'pointer' }}>
              <ChevronLeft size={15}/> {step === 0 ? 'Cancel' : 'Back'}
            </button>
            <div style={{ display:'flex', alignItems:'center', gap:8 }}>
              {STEPS.map((s, i) => (<div key={i} style={{ width: i === step ? 20 : 8, height:8, borderRadius:4, background: i < step ? '#0FA968' : i === step ? '#16213E' : '#D1D5DB', transition:'all 0.2s' }} />))}
            </div>
            {step < STEPS.length - 1 ? (
              <button onClick={this.handleNext.bind(this)} style={{ display:'flex', alignItems:'center', gap:6, padding:'10px 22px', borderRadius:10, border:'none', background:'#16213E', fontSize:13, fontWeight:700, color:'#fff', cursor:'pointer' }}>
                Next <ChevronRight size={15}/>
              </button>
            ) : (
              <button onClick={()=>this.handleSubmit()} disabled={saving} style={{ display:'flex', alignItems:'center', gap:7, padding:'10px 24px', borderRadius:10, border:'none', background:saving?'#9CA3AF':'#0FA968', fontSize:13, fontWeight:700, color:'#fff', cursor:saving?'not-allowed':'pointer' }}>
                {saving ? <><RefreshCw size={13} style={{animation:'spin 1s linear infinite'}}/> Saving…</> : <><Save size={14}/> {agent ? 'Update Agent' : 'Save Agent'}</>}
              </button>
            )}
          </div>
        </div>
        <style>{`@keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}`}</style>
      </div>
    );
  }
}

// ── Main Page ─────────────────────────────────────────────────────────────────
class AgentsPage extends Component {
  constructor(props) {
    super(props);
    this.state = { agents:[], loading:true, search:'', showModal:false, editAgent:null, expanded:{}, showBulkUpload:false };
    this.fetch       = this.fetch.bind(this);
    this.handleSaved = this.handleSaved.bind(this);
  }
  componentDidMount() {
    this.fetch();
    if (this.props.autoOpenAdd) this.setState({ showModal: true, editAgent: null });
  }

  async fetch() {
    this.setState({ loading:true });
    try {
      const { data } = await api.get('/agents', { params:{ search: this.state.search } });
      this.setState({ agents: data.data||[] });
    } catch { toast.error('Failed to load agents'); }
    finally { this.setState({ loading:false }); }
  }

  async handleEdit(id) {
    try {
      const { data } = await api.get(`/agents/${id}`);
      this.setState({ showModal: true, editAgent: data.data });
    } catch { toast.error('Failed to load agent details'); }
  }

  handleSaved(agent) {
    this.setState({ showModal:false, editAgent:null });
    this.fetch();
    if (this.props.onReturnToBooking) this.props.onReturnToBooking(agent);
  }

  async handleToggle(id) {
    try { const r = await api.patch(`/agents/${id}/toggle`); toast.success(r.data.message); this.fetch(); }
    catch(e) { toast.error(e.response?.data?.message||'Failed'); }
  }

  async handleDelete(id, name) {
    if (!window.confirm(`Delete "${name}"?`)) return;
    try { await api.delete(`/agents/${id}`); toast.success('Deleted'); this.fetch(); }
    catch(e) { toast.error(e.response?.data?.message||'Cannot delete'); }
  }

  toggleExpand(id) { this.setState(prev=>({ expanded:{...prev.expanded,[id]:!prev.expanded[id]} })); }

  render() {
    const { agents, loading, search, showModal, editAgent, expanded, showBulkUpload } = this.state;
    const { user } = this.props;

    const role      = user?.role_name || '';
    const canWrite  = ['Admin', 'Manager', 'Staff'].includes(role);
    const canDelete = role === 'Admin';

    return (
      <div>
        <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', marginBottom:20, flexWrap:'wrap', gap:12 }}>
          <div>
            <h1 style={{ fontSize:26, fontWeight:800, color:'#16213E', letterSpacing:'-0.02em' }}>Agent <span style={{color:'#FF6B4A'}}>Master</span></h1>
            <p style={{ fontSize:13, color:'#6B7280', marginTop:3 }}>{agents.length} agents registered</p>
          </div>
          {canWrite && (
            <div style={{ display:'flex', gap:10 }}>
              <button onClick={()=>this.setState({showBulkUpload:true})}
                style={{ display:'flex', alignItems:'center', gap:7, padding:'11px 20px', borderRadius:12, border:'1.5px solid #D1D5DB', background:'#fff', color:'#374151', fontSize:13, fontWeight:600, cursor:'pointer' }}>
                <Upload size={15}/> Bulk Upload
              </button>
              <button onClick={()=>this.setState({showModal:true,editAgent:null})}
                style={{ display:'flex', alignItems:'center', gap:7, padding:'11px 22px', borderRadius:12, border:'none', background:'#FF6B4A', color:'#fff', fontSize:13, fontWeight:700, cursor:'pointer', boxShadow:'0 4px 14px rgba(255,107,74,0.28)' }}>
                <Plus size={16}/> Add Agent
              </button>
            </div>
          )}
        </div>

        <div style={{ display:'flex', gap:10, marginBottom:16, flexWrap:'wrap' }}>
          <div style={{ position:'relative', flex:1, minWidth:220 }}>
            <Search size={14} style={{ position:'absolute', left:12, top:'50%', transform:'translateY(-50%)', color:'#9CA3AF' }} />
            <input type="text" value={search} placeholder="Search agency, director…"
              onChange={e=>this.setState({search:e.target.value},()=>{ clearTimeout(this._t); this._t=setTimeout(()=>this.fetch(),400); })}
              style={{ width:'100%', paddingLeft:36, paddingRight:14, paddingTop:9, paddingBottom:9, border:'1.5px solid #D1D5DB', borderRadius:10, fontFamily:'Sora,sans-serif', fontSize:13, color:'#111827', background:'#fff', outline:'none' }} />
          </div>
          <button onClick={this.fetch} style={{ display:'flex', alignItems:'center', gap:6, padding:'9px 16px', borderRadius:10, border:'1.5px solid #D1D5DB', background:'#fff', fontSize:13, fontWeight:600, color:'#374151', cursor:'pointer' }}>
            <RefreshCw size={13}/> Refresh
          </button>
        </div>

        <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
          {loading ? (
            <div style={{ textAlign:'center', padding:'60px 0', color:'#9CA3AF' }}>
              <RefreshCw size={24} style={{ animation:'spin 1s linear infinite', marginBottom:12 }}/><p>Loading…</p>
            </div>
          ) : agents.length === 0 ? (
            <div style={{ textAlign:'center', padding:'60px 0', color:'#9CA3AF' }}>
              <Users size={36} style={{ color:'#D1D5DB', marginBottom:14 }} />
              <p style={{ fontSize:15, fontWeight:600, color:'#374151' }}>No agents found</p>
            </div>
          ) : agents.map(a => (
            <div key={a.id} style={{ background:'#fff', border:'1px solid #E5E7EB', borderRadius:14, overflow:'hidden', boxShadow:'0 1px 4px rgba(0,0,0,0.04)' }}>
              <div style={{ padding:'14px 18px', display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:10 }}>
                <div style={{ display:'flex', alignItems:'center', gap:14, flex:1 }}>
                  <div style={{ width:40, height:40, borderRadius:12, background:'#FF6B4A', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, color:'#fff', fontSize:15, fontWeight:800, fontFamily:'Sora,sans-serif' }}>
                    {(a.agency_name||'?').trim().charAt(0).toUpperCase()}
                  </div>
                  <div>
                    <div style={{ fontWeight:700, color:'#111827', fontSize:14 }}>{a.agency_name}</div>
                    <div style={{ fontSize:12, color:'#6B7280', marginTop:2 }}>
                      {a.director_name && <span>{a.director_name} · </span>}
                      {a.phone && <span>{a.phone} · </span>}
                      <span style={{ color: a.operation_type==='Multiple Branches'?'#2F5FE0':'#9CA3AF' }}>{a.operation_type}</span>
                      {a.booking_limit && <span> · Limit: {a.booking_limit}</span>}
                      {a.agent_type && (
                        <span style={{
                          marginLeft: 4,
                          fontSize: 10, fontWeight: 700,
                          background: a.agent_type==='Buyers'?'#EFF6FF': a.agent_type==='Seller'?'#F0FDF4':'#F5F3FF',
                          color:      a.agent_type==='Buyers'?'#1D4ED8': a.agent_type==='Seller'?'#15803D':'#6D28D9',
                          border:     `1px solid ${a.agent_type==='Buyers'?'#BFDBFE': a.agent_type==='Seller'?'#BBF7D0':'#DDD6FE'}`,
                          borderRadius: 20, padding: '1px 8px',
                        }}>
                          {a.agent_type}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div style={{ display:'flex', gap:6, alignItems:'center', flexWrap:'wrap' }}>
                  <span style={{ padding:'3px 10px', borderRadius:20, fontSize:11, fontWeight:600, background: a.is_active?'#E4F9EE':'#FCEAE8', color: a.is_active?'#0B7A4C':'#B5382D', border:`1px solid ${a.is_active?'#BEEED9':'#F5CAC5'}` }}>
                    {a.is_active?'● Active':'○ Inactive'}
                  </span>
                  <button onClick={()=>this.toggleExpand(a.id)} style={{ background:'#F9FAFB', border:'1px solid #E5E7EB', borderRadius:8, padding:'6px 10px', cursor:'pointer', display:'flex', alignItems:'center', gap:4, fontSize:12, color:'#374151' }}>
                    {expanded[a.id]?<><ChevronUp size={13}/> Less</>:<><ChevronDown size={13}/> More</>}
                  </button>

                  {canWrite ? (
                    <button onClick={()=>this.handleEdit(a.id)} title="Edit"
                      style={{ width:30, height:30, borderRadius:8, border:'1px solid #BFDBFE', background:'#EFF6FF', color:'#1D4ED8', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}>
                      <Edit2 size={13}/>
                    </button>
                  ) : (
                    <span style={{ fontSize:10, background:'#F3F4F6', color:'#9CA3AF', borderRadius:20, padding:'2px 8px', fontWeight:600 }}>
                      View Only
                    </span>
                  )}

                  {canDelete && (
                    <>
                      <button onClick={()=>this.handleToggle(a.id)} title={a.is_active?'Deactivate':'Activate'}
                        style={{ width:30, height:30, borderRadius:8, border:`1px solid ${a.is_active?'#FDE68A':'#BBF7D0'}`, background:a.is_active?'#FFFBEB':'#F0FDF4', color:a.is_active?'#92400E':'#166634', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}>
                        {a.is_active?<ToggleLeft size={13}/>:<ToggleRight size={13}/>}
                      </button>
                      <button onClick={()=>this.handleDelete(a.id,a.agency_name)} title="Delete"
                        style={{ width:30, height:30, borderRadius:8, border:'1px solid #F5CAC5', background:'#FCEAE8', color:'#E1483A', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}>
                        <Trash2 size={13}/>
                      </button>
                    </>
                  )}
                </div>
              </div>

              {expanded[a.id] && (
                <div style={{ borderTop:'1px solid #F3F4F6', padding:'12px 18px', background:'#FAFBFF' }}>
                  <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(200px,1fr))', gap:14, marginBottom: (a.branches?.length||0)>0 ? 14 : 0 }}>
                    {a.email && <div><div style={{ fontSize:10, fontWeight:700, letterSpacing:'0.08em', textTransform:'uppercase', color:'#9CA3AF', marginBottom:3 }}>Email</div><div style={{ fontSize:13, color:'#374151', wordBreak:'break-all' }}>{a.email}</div></div>}
                    {a.gstin && <div><div style={{ fontSize:10, fontWeight:700, letterSpacing:'0.08em', textTransform:'uppercase', color:'#9CA3AF', marginBottom:3 }}>GSTIN</div><div style={{ fontSize:13, color:'#374151', fontFamily:'JetBrains Mono,monospace', wordBreak:'break-all' }}>{a.gstin}</div></div>}
                    {a.billing_state && <div><div style={{ fontSize:10, fontWeight:700, letterSpacing:'0.08em', textTransform:'uppercase', color:'#9CA3AF', marginBottom:3 }}>State</div><div style={{ fontSize:13, color:'#374151' }}>{a.billing_state}</div></div>}
                    {a.registered_address && <div style={{ gridColumn:'1/-1' }}><div style={{ fontSize:10, fontWeight:700, letterSpacing:'0.08em', textTransform:'uppercase', color:'#9CA3AF', marginBottom:3 }}>Address</div><div style={{ fontSize:13, color:'#374151' }}>{a.registered_address}</div></div>}
                  </div>
                  {(a.branches?.length||0) > 0 && (
                    <div style={{ marginTop:8 }}>
                      <div style={{ fontSize:10, fontWeight:700, letterSpacing:'0.08em', textTransform:'uppercase', color:'#9CA3AF', marginBottom:8 }}>Branches ({a.branches.length})</div>
                      <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                        {a.branches.map((b,i) => (
                          <div key={i} style={{ display:'flex', alignItems:'center', gap:10, padding:'8px 12px', background:'#EFF6FF', borderRadius:8, fontSize:12 }}>
                            <span style={{ color:'#6B7280' }}>📍</span>
                            <span style={{ fontWeight:600, color:'#1D4ED8' }}>{b.branch_name}</span>
                            {b.manager_name && <span style={{ color:'#6B7280' }}>· {b.manager_name}</span>}
                            {b.manager_phone && <span style={{ color:'#9CA3AF' }}>· {b.manager_phone}</span>}
                            {b.billing_state && <span style={{ color:'#9CA3AF', marginLeft:'auto' }}>{b.billing_state}</span>}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>

        {!canWrite && (
          <div style={{ marginTop:16, padding:'12px 18px', borderRadius:12, background:'#FFFBEB', border:'1px solid #FDE68A', display:'flex', alignItems:'center', gap:10, fontSize:13, color:'#92400E' }}>
            <Shield size={15}/> You have view-only access. Contact Admin, Manager or Staff to add or edit agents.
          </div>
        )}

        {showModal && <AgentModal agent={editAgent} onClose={()=>this.setState({showModal:false,editAgent:null})} onSaved={this.handleSaved} />}
        {showBulkUpload && (
          <BulkAgentUpload
            onClose={()=>this.setState({showBulkUpload:false})}
            onImported={()=>{ this.setState({showBulkUpload:false}); this.fetch(); }}
          />
        )}
        <style>{`@keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}`}</style>
      </div>
    );
  }
}

export default AgentsPage;